/* © 2018-2022 TakuLabs Ltd. All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential */

import { Location } from "@angular/common";
import { Component, Output, EventEmitter } from "@angular/core";
import { GenericFormComponent } from "../../../../forms/generic-form/generic-form.component";
import { AccountGroup } from "./account-group";
import { AccountGroupService } from "./account-group.service";
import { Router, ActivatedRoute } from "@angular/router";
import { UntypedFormBuilder } from "@angular/forms";
import { DBService } from "../../../../shared/services/db.service";
import { MessageService, ConfirmationService } from "primeng/api";
import { AlertMessagesService } from "../../../../shared/services/alert-messages.service";
import { AppSettingsStorageService } from "../../../../shared/app-settings-storage.service";
import { AppComponent } from "src/app/app.component";

@Component({
  selector: "taku-account-group",
  templateUrl: "./account-group.component.html",
  styleUrls: ["./account-group.component.scss"],
})
export class AccountGroupComponent extends GenericFormComponent {
  @Output() dialogClosed = new EventEmitter<any>();
  enum_options = this.accGroupService.get_enum_options();

  constructor(
    public accGroupService: AccountGroupService,
    protected _router: Router,
    public fb: UntypedFormBuilder,
    public dbService: DBService,
    protected location: Location,
    public _route: ActivatedRoute,
    protected messageService: MessageService,
    protected alertMessage: AlertMessagesService,
    protected confirmationService: ConfirmationService,
    appSettings: AppSettingsStorageService
  ) {
    super(_router, fb, dbService, location, _route, messageService, alertMessage, confirmationService, appSettings);
  }

  initForm() {
    this._model = "acctGroup";
    this._object = new AccountGroup();
    this._myForm = this.fb.group(new AccountGroup());
  }

  initValidation() {
    this._validation = this.accGroupService.getValidationRules();
  }

  closeModal() {
    this.dialogClosed.emit();
  }
}

/* © 2018-2022 TakuLabs Ltd. All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential */
